import { Environment } from '@rhg/constants';
import { getChEventsAnalyticsUrl } from '../ch-events-config';
import { createAmplitudeDestination } from './amplitude';
import { createDebugDestination } from './debug';
import { AnalyticsDestination } from './types';

interface AnalyticsDestinationProps {
    amplitudeToken: string;
    amplitudeBaseUrl: string;
    chEventsProxyEnabled?: boolean;
    chEventsProxyUrl?: string;
    env: Environment;
    debug?: boolean;
}

function resolveAmplitudeServerUrl({
    chEventsProxyEnabled,
    chEventsProxyUrl,
    amplitudeBaseUrl,
}: Pick<
    AnalyticsDestinationProps,
    'chEventsProxyEnabled' | 'chEventsProxyUrl' | 'amplitudeBaseUrl'
>): string {
    if (chEventsProxyEnabled && chEventsProxyUrl) {
        return getChEventsAnalyticsUrl(chEventsProxyUrl);
    }
    return amplitudeBaseUrl;
}

export function createDestinations({
    amplitudeToken,
    amplitudeBaseUrl,
    chEventsProxyEnabled = false,
    chEventsProxyUrl = '',
    env,
    debug = false,
}: AnalyticsDestinationProps): AnalyticsDestination[] {
    const destinations = [];
    const serverUrl = resolveAmplitudeServerUrl({
        chEventsProxyEnabled,
        chEventsProxyUrl,
        amplitudeBaseUrl,
    });
    if (amplitudeToken && serverUrl) {
        destinations.push(
            createAmplitudeDestination(amplitudeToken, env, serverUrl)
        );
    }
    if (debug) {
        destinations.push(createDebugDestination());
    }
    return destinations;
}
